import { Box, Typography, useMediaQuery } from "@material-ui/core";
import { FC } from "react";
import theme from "./theme";

const TimerFormat: FC<any> = ({
  days,
  hours,
  mins,
  secs,
  format,
  homeTimer,
  isSticky,
}) => {
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
     {format ? (
       <>
      <Box display="flex" textAlign="center" className={` ${homeTimer ? "homeTimer" : "timerstyle"} `}    >
      <Box mr={homeTimer ? (isActive ? "10px" : 3 ) : "10px"} >
        {hours.map((digit:any) =>(
            <span className={`text-black  ${isSticky===true ? "stickyHomeTimer" :""} `}>
              <Typography variant={homeTimer ? "h3" : "h6"} color="secondary" >{digit}</Typography>
              </span>
        ))}
         
        <Typography variant="subtitle1" className={`fw-normal ${isSticky===true ? "fs-10" :""} `} >HOURS</Typography>
      </Box>
      <Box mr={homeTimer ? (isActive ? "10px" : 3 ) : "10px"} >
      {mins.map((digit:any) =>(
            <span className={`text-black  ${isSticky===true ? "stickyHomeTimer" :""} `}   >
              <Typography variant={homeTimer ? "h3" : "h6"} color="secondary">{digit}</Typography>
              </span>
        ))}
        <Typography variant="subtitle1" className={`fw-normal ${isSticky===true ? "fs-10" :""} `} >MINUTES</Typography>
      </Box>
      <Box mr={homeTimer ? (isActive ? "0px" : 3 ) : "10px"}>
      {secs.map((digit:any) =>(
            <span className={`text-black  ${isSticky===true ? "stickyHomeTimer" :""} `}  >
              <Typography variant={homeTimer ? "h3" : "h6"} color="secondary">
              {digit}
              </Typography>
              </span>
        ))}
        <Typography variant="subtitle1" className={`fw-normal ${isSticky===true ? "fs-10" :""} `} >SECONDS</Typography>
      </Box>
    </Box>
    </>
    ) : (
      <>
      <Box display="flex" textAlign="center" className={` ${homeTimer ? "homeTimer" : "timerstyle"} `}    >
        <Box mr={homeTimer ? (isActive ? "10px" : 3 ) : "10px"} >
          {days.map((digit:any) =>(
              <span className={`text-black  ${isSticky===true ? "stickyHomeTimer" :""} `}>
                <Typography variant={homeTimer ? "h3" : "h6"} color="secondary" >{digit}</Typography>
                </span>
          ))}
           
          <Typography variant="subtitle1" className={`fw-normal ${isSticky===true ? "fs-10" :""} `} >DAYS</Typography>
        </Box>
        <Box mr={homeTimer ? (isActive ? "10px" : 3 ) : "10px"} >
        {hours.map((digit:any) =>(
              <span className={`text-black  ${isSticky===true ? "stickyHomeTimer" :""} `}   >
                <Typography variant={homeTimer ? "h3" : "h6"} color="secondary">{digit}</Typography>
                </span>
          ))}
          <Typography variant="subtitle1" className={`fw-normal ${isSticky===true ? "fs-10" :""} `} >HOURS</Typography>
        </Box>
        <Box mr={homeTimer ? (isActive ? "0px" : 3 ) : "10px"}>
        {mins.map((digit:any) =>(
              <span className={`text-black  ${isSticky===true ? "stickyHomeTimer" :""} `}  >
                <Typography variant={homeTimer ? "h3" : "h6"} color="secondary">
                {digit}
                </Typography>
                </span>
          ))}
          <Typography variant="subtitle1" className={`fw-normal ${isSticky===true ? "fs-10" :""} `} >MINUTES</Typography>
        </Box>
      </Box>
      </>
      )}
      </>
  );
}
export default TimerFormat;
